import { Dispatch, FunctionComponent, SetStateAction, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import Body3 from 'design-system/Typography/Body/Body3'
import Label from 'design-system/Typography/Label/Label'

import {
  Condo,
  Coop,
  Detached,
  DuplexTriplex,
  Land,
  OtherHomeType,
  Townhouse,
} from 'components/SVG/homeTypes'
import Spacer from 'components/Spacer'

import * as E from 'types/enums'

interface ISelectedProp {
  selected: boolean
}
const HomeTypeButton = styled.div<ISelectedProp>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 62px;
  border: 1px solid ${props => props.theme.colors[props.selected ? 'teal500' : 'neutral900']};
  background-color: ${props => props.theme.colors[props.selected ? 'teal50' : 'white']};
  border-radius: ${props => props.theme.radii[4]}px;
  cursor: pointer;

  :hover {
    border: 1px solid ${props => props.theme.colors.teal500};
  }

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    width: 88px;
  }
`

const HomeTypeIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  width: 28px;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: ${props => props.theme.spacings[8]}px;
  width: 100%;
`

interface IProps {
  setSelectedHomeTypes: Dispatch<SetStateAction<E.HomeTypeEnum[]>>
  selectedHomeTypes: E.HomeTypeEnum[]
}

const HomeTypeSelectionInput: FunctionComponent<IProps> = ({
  setSelectedHomeTypes,
  selectedHomeTypes,
}) => {
  const theme = useContext(ThemeContext)

  const handleSelectionChange = (value: E.HomeTypeEnum) => {
    let newSelection = [...selectedHomeTypes]

    if (selectedHomeTypes.includes(value)) {
      newSelection = newSelection.filter(type => type !== value)
    } else {
      newSelection = [...selectedHomeTypes, value]
    }

    setSelectedHomeTypes(newSelection)
  }

  const handleClickHome = () => handleSelectionChange(E.HomeTypeEnum.detached)
  const handleClickCondo = () => handleSelectionChange(E.HomeTypeEnum.condo)
  const handleClickCoop = () => handleSelectionChange(E.HomeTypeEnum.coop)
  const handleClickTownhouse = () => handleSelectionChange(E.HomeTypeEnum.townhouse)
  const handleClickDuplex = () => handleSelectionChange(E.HomeTypeEnum.duplex)
  const handleClickLand = () => handleSelectionChange(E.HomeTypeEnum.land)
  const handleClickOther = () => handleSelectionChange(E.HomeTypeEnum.other)

  return (
    <>
      <Body3>Home Type</Body3>
      <Spacer size={theme.spacings[8]} />
      <Grid>
        <HomeTypeButton
          onClick={handleClickHome}
          selected={selectedHomeTypes.includes(E.HomeTypeEnum.detached)}
        >
          <HomeTypeIconContainer>
            <Detached
              height={28}
              fill={theme.colors.black}
            />
          </HomeTypeIconContainer>
          <Spacer size={theme.spacings[4]} />
          <Label>House</Label>
        </HomeTypeButton>
        <HomeTypeButton
          onClick={handleClickCondo}
          selected={selectedHomeTypes.includes(E.HomeTypeEnum.condo)}
        >
          <HomeTypeIconContainer>
            <Condo
              height={28}
              fill={theme.colors.black}
            />
          </HomeTypeIconContainer>
          <Spacer size={theme.spacings[4]} />
          <Label>Condo</Label>
        </HomeTypeButton>
        <HomeTypeButton
          onClick={handleClickCoop}
          selected={selectedHomeTypes.includes(E.HomeTypeEnum.coop)}
        >
          <HomeTypeIconContainer>
            <Coop
              height={28}
              fill={theme.colors.black}
            />
          </HomeTypeIconContainer>
          <Spacer size={theme.spacings[4]} />
          <Label>Coop</Label>
        </HomeTypeButton>
        <HomeTypeButton
          onClick={handleClickTownhouse}
          selected={selectedHomeTypes.includes(E.HomeTypeEnum.townhouse)}
        >
          <HomeTypeIconContainer>
            <Townhouse
              height={28}
              fill={theme.colors.black}
            />
          </HomeTypeIconContainer>
          <Spacer size={theme.spacings[4]} />
          <Label>Townhouse</Label>
        </HomeTypeButton>
        <HomeTypeButton
          onClick={handleClickDuplex}
          selected={selectedHomeTypes.includes(E.HomeTypeEnum.duplex)}
        >
          <HomeTypeIconContainer>
            <DuplexTriplex
              height={28}
              fill={theme.colors.black}
            />
          </HomeTypeIconContainer>
          <Spacer size={theme.spacings[4]} />
          <Label>Duplex/Triplex</Label>
        </HomeTypeButton>
        <HomeTypeButton
          onClick={handleClickLand}
          selected={selectedHomeTypes.includes(E.HomeTypeEnum.land)}
        >
          <HomeTypeIconContainer>
            <Land
              height={28}
              fill={theme.colors.black}
            />
          </HomeTypeIconContainer>
          <Spacer size={theme.spacings[4]} />
          <Label>Land</Label>
        </HomeTypeButton>
        {/*
          <HomeTypeButton>
            <HomeTypeIconContainer>
              <Manufactured
                height={28}
                fill={theme.colors.black}
              />
            </HomeTypeIconContainer>
            <Spacer size={theme.spacings[4]} />
            <Label>Manufactured</Label>
          </HomeTypeButton>
        */}
        <HomeTypeButton
          onClick={handleClickOther}
          selected={selectedHomeTypes.includes(E.HomeTypeEnum.other)}
        >
          <HomeTypeIconContainer>
            <OtherHomeType
              height={28}
              fill={theme.colors.black}
            />
          </HomeTypeIconContainer>
          <Spacer size={theme.spacings[4]} />
          <Label>Other</Label>
        </HomeTypeButton>
      </Grid>
    </>
  )
}

export default HomeTypeSelectionInput
